import type { RouteLocationNormalized, Router } from "vue-router";

export const recruitmentSettingRouteName = {
  index: "recruitmentSettings.index",
  show: "recruitmentSettings.show",
};

export const recruitmentSettingRoute = [
  {
    path: "/recruitment-settings",
    name: recruitmentSettingRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "recruitment_setting",
      breadcrumbs: () => {
        return [{ title: "Recruitment Setting" }];
      },
    },
  },
  {
    path: "/recruitment-settings/:id",
    name: recruitmentSettingRouteName.show,
    component: () => import("../pages/DetailPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "recruitment_setting",
      breadcrumbs: (_to: RouteLocationNormalized, router: Router) => {
        return [{ path: router.resolve({ name: recruitmentSettingRouteName.index }).path, title: "Recruitment Setting" }, { title: "Detail" }];
      },
    },
  },
];
